import React from 'react';
import {DoppeBymoPageFreemiumBannerType} from "../../client-server-common";
import {useBymoPageContextProps} from "../../doppe-sdk";
import {DoppeBymoPageFooterBannerHopp} from "../doppe-bymo-page-footer-banner-hopp/doppe-bymo-page-footer-banner-hopp";
import {
    DoppeBymoPageFooterBannerPaypal
} from "../doppe-bymo-page-footer-banner-paypal/doppe-bymo-page-footer-banner-paypal";

export const DoppePageFooterBanner = React.memo(function DoppePageFooterBanner (props: DoppePageFooterBanner.Props) {
    const {
        targetUrl = `https://www.hopp.co`,

        className,
        ...htmlAttributes
    } = props;

    const bymoPageContextProps = useBymoPageContextProps();
    switch (bymoPageContextProps.freemiumBannerType) {
        case DoppeBymoPageFreemiumBannerType.HoppDefault: {
            return (
                <DoppeBymoPageFooterBannerHopp
                    targetUrl={targetUrl}
                    className={className}
                    {...htmlAttributes}
                />
            )
        }
        case DoppeBymoPageFreemiumBannerType.PayPalBio: {
            return (
                <DoppeBymoPageFooterBannerPaypal
                    targetUrl={targetUrl}
                    className={className}
                    {...htmlAttributes}
                />
            )
        }
    }
});

export namespace DoppePageFooterBanner {

    export interface Props extends React.HTMLAttributes<any> {
        targetUrl?: string;
    }
}
